module.exports = __webpack_public_path__ + "static/media/dot_menu.b7000690.svg";